"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Context = require("../Context");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createListener = function createListener(onChange, bp) {
  return function (_ref) {
    var matches = _ref.matches;
    onChange(_defineProperty({}, bp.key, matches));
  };
};

var BreakpointsProvider = function BreakpointsProvider(_ref2) {
  var children = _ref2.children,
      breakpoints = _ref2.breakpoints;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      activeBreakpoint = _useState2[0],
      updateBreakpoint = _useState2[1];

  var _useState3 = (0, _react.useState)(breakpoints.reduce(function (acc, bp) {
    return _objectSpread({}, acc, _defineProperty({}, bp.key, bp.query.matches));
  }, {
    isTouchDevice: /Mobi|Tablet|iPad|iPhone|Android/.test(window.navigator.userAgent)
  })),
      _useState4 = _slicedToArray(_useState3, 2),
      device = _useState4[0],
      updateDevice = _useState4[1];

  var onChange = function onChange(bp) {
    updateBreakpoint(bp);
  };

  (0, _react.useEffect)(function () {
    updateDevice(_objectSpread({}, device, activeBreakpoint));
  }, [activeBreakpoint]);
  (0, _react.useEffect)(function () {
    var listeners = breakpoints.map(function (bp) {
      var listener = createListener(onChange, bp);
      bp.query.addListener(listener);
      return listener;
    });
    return function () {
      breakpoints.forEach(function (bp, i) {
        bp.query.removeListener(listeners[i]);
      });
    };
  }, []);
  return _react["default"].createElement(_Context.Provider, {
    value: device
  }, children);
};

var Breakpoints = function Breakpoints(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["children"]);

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      breakpoints = _useState6[0],
      defineBreakpoints = _useState6[1];

  (0, _react.useEffect)(function () {
    defineBreakpoints(Object.entries(props).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          key = _ref5[0],
          query = _ref5[1];

      return {
        key: key,
        query: window.matchMedia(query)
      };
    }));
  }, []);
  return breakpoints ? _react["default"].createElement(BreakpointsProvider, {
    breakpoints: breakpoints
  }, children) : null;
};

var _default = Breakpoints;
exports["default"] = _default;